import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const TAX_TOTAL_SCHEMA = Object.freeze({
    TAX_ID: '',
    RATE: 0,
    SUB_TOTAL: 0,
    TOTAL: 0,
  }),
  RECORD = generateSchema(TAX_TOTAL_SCHEMA),
  KEYS: any = generateKeys(TAX_TOTAL_SCHEMA);

export class TaxTotal extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get taxId(): string {
    return this.get(KEYS.TAX_ID);
  }

  get rate(): number {
    return this.get(KEYS.RATE);
  }

  get subTotal(): string {
    return this.get(KEYS.SUB_TOTAL);
  }

  get total(): number {
    return this.get(KEYS.TOTAL);
  }
}
